// /enter-school-code?mode=required|add (FR-024 to FR-027; P-JOIN-8, P-AUTH-2). `required` (after
// sign-in with no children): no way to Home; Log out, and Switch to school admin for a web dual-role
// user. `add` (004's entry points): Cancel goes back, else Home. A confirmed school hands off to Add
// student with source CODE.
import { useLocalSearchParams, useRouter } from "expo-router";

import { useSession, useSessionController } from "@/session/hooks";
import { usePlatform } from "@/session/platform";
import { servedRoles } from "@/session/store";
import { LinkButton } from "@/ui/LinkButton";

import { JOIN_COPY } from "./copy";
import { EnterSchoolCodeForm } from "./EnterSchoolCodeForm";
import { addStudentHref, handoff } from "./handoff";
import { JoinLayout } from "./JoinLayout";

export function EnterSchoolCodeScreen() {
  const params = useLocalSearchParams<{ mode?: string }>();
  const mode = params.mode === "required" ? "required" : "add";
  const router = useRouter();
  const session = useSession();
  const platform = usePlatform();
  const controller = useSessionController();
  const dualOnWeb =
    platform === "web" &&
    session.status === "signedIn" &&
    servedRoles(session.roles).includes("SCHOOL_ADMIN") &&
    servedRoles(session.roles).includes("PARENT");

  const footer =
    mode === "required" ? (
      <>
        {dualOnWeb ? (
          <LinkButton
            onPress={() =>
              void controller
                .switchRole("SCHOOL_ADMIN")
                .then(() => router.replace("/school"))
            }
          >
            {JOIN_COPY.codeStep.switchToSchoolAdmin}
          </LinkButton>
        ) : null}
        <LinkButton onPress={() => void controller.signOut("USER")}>
          {JOIN_COPY.codeStep.logOut}
        </LinkButton>
      </>
    ) : (
      <LinkButton
        onPress={() => (router.canGoBack() ? router.back() : router.replace("/"))}
      >
        {JOIN_COPY.codeStep.cancel}
      </LinkButton>
    );

  return (
    <JoinLayout header={false} testID="enter-school-code">
      <EnterSchoolCodeForm
        footer={footer}
        onConfirmed={(code, school) => {
          handoff.put({ code, source: "CODE", school });
          router.push(addStudentHref(code, "CODE"));
        }}
      />
    </JoinLayout>
  );
}
